<template>
  <div>
    <van-nav-bar title="登录">
      <template #right>
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img
          :src="require('../assets/images/logo.png')"
          style="width: 100%"
        />
      </div>
      <van-form @submit="onLogin">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          label="手机号"
          placeholder="请输入手机号"
          autocomplete="off"
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
          >
            登录
          </van-button>
        </div>
      </van-form>
      <van-row>
        <van-col span="12">
          <router-link to="/registered">
            <p class="register">立即注册</p>
          </router-link>
        </van-col>
        <van-col span="12">
          <router-link to="/forget">
            <p class="forget">忘记密码?</p>
          </router-link>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version } from "../../package";
import CimSdk from "../assets/cim/cim.web.sdk";
import eventBus from "../assets/js/eventBus";
export default {
  name: "Login",
  data() {
    return {
      phone: "",
      password: "",
      isFromChat: "",
      qserver_url: "",
    };
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url});
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onLogin(values) {
      let that = this;
      const toast = that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: "加载中...",
      });
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.phone.toString();
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      let userPasword = that.encryptMessage(that.password, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "login_e",
            phone: phoneNumber,
            password: userPasword,
            app_version: version,
          },
        })
        .then(function (res) {
          let resData = res.data;
          localStorage.setItem("password", that.password);
          if (resData.code === 1) {
            toast.clear();
            window.sessionStorage.setItem("loginType", true);
            window.sessionStorage.setItem("token", resData.data.token);
            that.$store.commit("changeLoginType", true);
            that.$store.commit("changePhone", that.phone);
            if(process.env.AUTO_LOGIN) {
              window.localStorage.setItem("al",btoa(JSON.stringify({u:userPhone,p:that.password})));
            }
            let user_number = resData.data.user_number;
            localStorage.setItem("user_number", user_number);
            // CimSdk.connect(this);
            eventBus.$emit("startChat");

            that.isFromChat
              ? that.$router.push({
                  path: "service_chat",
                  query: { account: user_number },
                })
              : that.$router.push("/member");
            //call login service in chat
            that.loginService();
          } else if (resData.code === 0) {
            toast.clear();
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          toast.clear();
        });
    },
    loginService() {
      let accountNumber = localStorage.getItem("user_number");
      let password = localStorage.getItem("password");
      // console.log("account", accountNumber);
      this.$http({
        url: this.$chatApiURL + "/api/user/login",
        method: "post",
        data: {
          account: accountNumber,
          password: md5(password),
        },
      }).then(function (res) {
        if (res.data.code == 200) {
          window.localStorage.chatToken = res.data.token;
        }
      });
      // $.post("http://47.242.244.129:9080/api/user/login", {account:accountNumber,password:md5(password)},
      //   function(data){
      //     console.log("dataegrger",data);
      //     if(data.code==200){
      //       // window.localStorage.token = data.token;
      //       // window.localStorage.account = account;
      //       // CIMPushManager.connect();
      //     }
      // });
    },
    isLogin() {
      let that = this;
      if (that.$store.state.loginType) {
        this.$router.push("/member");
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
  },
  mounted: function () {
    this.get_qchat_server_url();
    this.$route.query.chat
      ? (this.isFromChat = true)
      : (this.isFromChat = false);
    this.isLogin();
  },
  created(){

  }
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 100px auto 0;
}
.register {
  margin: 0;
  font-size: 14px;
  color: #e30614;
}
.forget {
  margin: 0;
  font-size: 14px;
  text-align: right;
  color: #e30614;
}
.chatTextDesign {
  border: 1px solid #ffffff;
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue